/**
 * @mixin
 * Sharable mixing to use with any type of components
 */
export default {
    props: {
        /**
		 * @description 
         * The index within the components loop this component sits at (zero-indexed)
         */
        index : {
            type : Number,
			required: false,
			default: () => 0
        },

		/**
		 * @description
         * The id of the component
         */
		id: {
			type: String,
			required: false,
			default: () => null
		},

		/**
		 * @description
		 * The component title
		 */
		title: {
			type: String,
			required: false,
			default: () => ''
		},

		tooltip: {
			type: String,
			required: false,
			default: ''
		},

		/**
		 * @description
		 * The component logo
		 */
		headerLogo: {
			type: String,
			required: false,
			default: () => ''
		},

        /**
		 * @description
		 * 
         * The user object
         * 
		 * @see [wiki] (https://www.corestream.co.uk)
         */
        user : {
            type : Object,
			required : false,
			default: () => null
		},
		
		/**
		 * @description
		 * The entity theme object
		 */
		theme: {
			type: Object,
			required: false,
			default: () => {}
		},

		/**
		 * @description
		 * The entites array
		 */
		entities: {
			type: Array,
			required: false,
			default: () => []
		},

        /**
		 * @description
         * Whether the component is being included as part of a child of a drilldown
         */
        inDrilldown : {
            type : Boolean,
            required : false,
			default: () => false,
		},
		
		/**
		 * @description
         * Whether the component is page component
         */
		isPage: {
			type: Boolean,
			required: false
		},
        
        /**
		 * @description
         * The settings for the component. Provided in object form
         * @see See [Wiki](https://www.corestream.co.uk)
         */
        componentSettings : {
            type: Object,
			required : false,
			default: () => {}
		},

		/**
		 * @description
         * The settings for the component. Provided in object form
         * @see See [Wiki](https://www.corestream.co.uk)
         */
		 componentData : {
            type: Object,
			required : false,
			default: () => {}
		},

		rootLevelHelpText: {
			type: String,
			default: ""
		}
    },

	methods: {
		/**
		 * @public
		 * @description
		 * If we have supplied any component translations we will add them to our LOCAL locale here
		 */
		addAppliedComponentTranslations() {
			if (this.$cs_.get(this.componentData, 'translations')) {
				this.$transformAndAddTranslations(this.componentData.translations, '');
			}
		}
	}
}
